import { globalTheme, useMixin } from '@clds/component-theme';
import { StyledSvg } from './StyledSvg';

export const GettingStartedIcon = () => {
  return (
    <StyledSvg viewBox="0 0 10 14" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.99969 13.6668C4.64933 13.6668 4.34827 13.521 4.0965 13.2294C3.84474 12.9378 3.72335 12.5804 3.73234 12.1571H6.26799C6.27698 12.5804 6.15543 12.9378 5.90335 13.2294C5.65126 13.521 5.35004 13.6668 4.99969 13.6668ZM2.63985 11.5786V10.0972H7.36047V11.5786H2.63985ZM2.8017 9.51868C2.07338 9.06718 1.47993 8.46064 1.02136 7.69906C0.562783 6.93747 0.333496 6.10486 0.333496 5.20122C0.333496 3.84908 0.787044 2.69975 1.69414 1.75325C2.60124 0.806747 3.70272 0.333496 4.99857 0.333496C6.29443 0.333496 7.39644 0.806747 8.30459 1.75325C9.21275 2.69975 9.66683 3.84908 9.66683 5.20122C9.66683 6.10409 9.43979 6.93651 8.98571 7.69848C8.53163 8.46045 7.93594 9.06718 7.19862 9.51868H2.8017Z"
        fill={useMixin(globalTheme.palette.contrastLow)}
      />
    </StyledSvg>
  );
};
